<script lang="ts" module>
	import type { HTMLAttributes } from "svelte/elements";
	import Formatted from "./Formatted.svelte";

	export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

	export interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
		readonly element?: HTMLHeadingElement;
		level: HeadingLevel;
		text: string;
	}
</script>

<script lang="ts">
	let {
		/* eslint-disable prefer-const */
		text,
		level,
		/* eslint-enable prefer-const */
		element = $bindable(),
		// eslint-disable-next-line prefer-const
		...props
	}: HeadingProps = $props();
	const tag = $derived(`h${level}` satisfies keyof HTMLElementTagNameMap);
</script>

<svelte:element this={tag} {...props} bind:this={element}>
	<Formatted {text} />
</svelte:element>
